import { GridLines } from '#~/control/index.js';

/** Toggle titles. */
export const Titles = Object.freeze({
  [GridLines.None]: 'No Grid Lines',
  [GridLines.Thirds]: 'Rule of Thirds',
  [GridLines.Center]: 'Center Lines'
} satisfies Record<GridLines, string>);
